import { render, staticRenderFns } from "./controlCmp.vue?vue&type=template&id=c86169ae&"
import script from "./controlCmp.vue?vue&type=script&lang=ts&"
export * from "./controlCmp.vue?vue&type=script&lang=ts&"
import style0 from "./controlCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports